const translation = {
    "Marché": {
        "fr": "Marché",
        "en": "Market"
    },

    "monde": {
        "fr": "Monde",
        "en": "World"
    },
    users:{
        "fr": "Présences",
        "en": "Payers"
    },
    "ChatPrivate": {
        "fr": "Privées",
        "en": "Private"
    },
    "Pas de messages":{
        "fr": "Pas de messages clickez pour en envoyez",
        "en": "No more messages, click to send one"
    }
}

export const __ = (t) => {
    const l = navigator.languages[0].split("-")[0]
    if(translation[t] && translation[t][l]){
        return translation[t][l]
    }
    return t
}

export const Capitalize = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
    }
    